import BlogFeaturedImage from "./BlogFeaturedImage";

export default BlogFeaturedImage;
